import * as React from 'react';
import { IBlockProps } from '../../interface/block/block-props.interface';
import { BaseBlockDataModel } from '../../model/block/base-block-data.model';

export class BaseBlockView<T extends BaseBlockDataModel, P = {}> extends React.Component<IBlockProps<T> & P> {
  render() {
    return <div/>;
  }
}
